import ClassSpellListManager from './ClassSpellListManager';

export default ClassSpellListManager;
export { ClassSpellListManager };
